// extracted by mini-css-extract-plugin
module.exports = {"subscriptionmodule":"aimatch_subscriptionmodule__B40NP"};